import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

import { Consent } from 'src/app/core/entities/consent.entity';
import { ErrorService } from 'src/app/core/services/error.service';
import { Profile } from 'src/app/core/entities/profile.entity';
import { ProfileFormHandler } from 'src/app/core/form-handler/profile.form-handler';
import { ProfileService } from 'src/app/core/services/profile.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-consents',
  templateUrl: './consents.component.html',
  styleUrls: ['./consents.component.css'],
})
export class ConsentsComponent implements OnInit {
  @Input() settings = false;
  @Input() profile: Profile = new Profile();
  @Output() updatedConsents = new EventEmitter<FormGroup>();
  private _observers: Subscription = new Subscription();
  public profileFormHandler: ProfileFormHandler = new ProfileFormHandler(
    ProfileFormHandler.PROFILE_FORM_STEP_CONSENTS
  );
  public consentDataForm: FormGroup;

  constructor(
    private profileService: ProfileService,
    private spinnerService: SpinnerService,
    private toastrService: ToastrService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.prepareConsentForm();
    this.setObservers();
  }

  prepareConsentForm(): void {
    this.consentDataForm = this.profileFormHandler.init();
    this.consentDataForm.removeControl('consentHcpCgu');

    if (this.settings) {
      this.consentDataForm.removeControl('consentHcpMandatoryProcessing');
    }

    this.profileFormHandler.update(this.profile);
  }

  setObservers(): void {
    if (this.settings) {
      this._observers.add(this.onProfileDataChanged());
    }
  }

  onSubmit(): void {
    if (this.consentDataForm.valid) {
      this.updatedConsents.emit(this.consentDataForm);
    }
  }

  onProfileDataChanged(): Subscription {
    return this.profileFormHandler.dataChanged.subscribe((res) => {
      let data = {};

      res.forEach((profileData) => {
        if (
          profileData.formControl.valid &&
          this.profile[profileData.key] !== profileData.formControl.value
        ) {
          data[profileData.key] = profileData.formControl.value;
        }
      });

      if (Object.entries(data).length > 0) {
        this.updateProfile(data);
      }
    });
  }

  updateProfile(data: any): void {
    this.spinnerService.show();

    this.profileService
      .updateConsents(data)
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe({
        next: (res) => {
          Object.entries(res).forEach(([key, value]) => {
            this.profile.updateConsent(value as Consent);
          });

          // Update service profile
          this.profileService.me = this.profile;

          this.toastrService.success(
            $localize`:@@settings_editAccount_ProfileSuccess:`
          );
        },
        error: (err) => {
          this.errorService.addError(
            $localize`:@@settings_editAccount_ErrorDescription:A problem is occured, please retry later`
          );
          this.errorService.show();
        },
      });
  }
}
